function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("g", {
  id: "line-elements"
}, React.createElement("path", {
  d: "M300 306.84C296.83 305.14 294.84 304.09 294.05 303.66C290.97 302.02 287.14 303.19 285.5 306.28C280.25 316.24 268.29 338.9 263.25 348.46C260.58 353.5 257.18 358.12 253.15 362.15C251.9 363.4 256.47 358.83 255.78 359.52C250.01 365.29 242.63 369.18 234.62 370.68C234.62 370.68 234.62 370.68 234.62 370.68C233.08 379.14 229.49 384.79 223.85 387.61C218.21 390.43 210.51 390.43 200.77 387.61C192.69 397.99 185.26 402.61 178.46 401.45C171.67 400.3 165.51 393.38 160 380.68C147.95 383.12 139.49 381.58 134.62 376.07C129.74 370.55 128.46 361.07 130.77 347.61C120.9 339.02 115.77 330.55 115.38 322.22C115 313.89 119.36 305.68 128.46 297.61C128.72 283.76 132.05 274.53 138.46 269.91C144.87 265.3 154.36 265.3 166.92 269.91C177.31 261.2 187.05 256.84 196.15 256.84C205.26 256.84 213.72 261.2 221.54 269.91C232.95 266.84 241.41 267.61 246.92 272.22C250.29 275.04 252.42 280.08 253.33 287.35C254.16 294 257.18 300.18 261.91 304.93C263.2 306.24 259.83 302.84 261.13 304.15C265.78 308.83 272.1 311.45 278.69 311.45C279.17 311.45 280.38 311.45 282.31 311.45",
  id: "bD7cjVIlY"
}), React.createElement("path", {
  d: "M313.08 306.92C311.18 305.75 309.99 305.02 309.51 304.73C306.03 302.59 301.46 303.84 299.55 307.45C294.41 317.19 282.06 340.59 276.81 350.55C275.26 353.47 271.46 354.28 268.86 352.24C268.09 351.63 266.16 350.12 263.08 347.69",
  id: "b1lAVhPY5T"
}), React.createElement("path", {
  d: "M327.69 306.92C325.75 305.88 324.54 305.23 324.06 304.97C320.55 303.08 316.18 304.41 314.32 307.93C309.15 317.73 297.02 340.7 291.85 350.49C290.12 353.79 285.77 354.62 282.94 352.19C282.24 351.59 280.49 350.09 277.69 347.69",
  id: "aeZOsAkCO"
}), React.createElement("path", {
  d: "M308.46 343.85C313.14 343.85 316.07 343.85 317.24 343.85C321.03 343.85 324.71 345.08 327.74 347.35C329.88 348.96 327.27 346.99 328.31 347.78C334.87 352.7 339.55 359.71 341.58 367.66C343.07 373.51 345.37 377.88 348.46 380.77C354.23 386.15 362.44 388.46 373.08 387.69C385 398.97 396.03 404.62 406.15 404.62C416.28 404.62 425.51 398.97 433.85 387.69C448.27 391.91 459.04 391.91 466.15 387.69C473.26 383.47 476.72 375.03 476.51 362.38C487.49 353.75 493.52 345.01 494.62 336.15C495.71 327.3 491.86 318.32 483.08 309.23C485.64 295 484.62 285 480 279.23C475.38 273.46 467.18 271.92 455.38 274.62C446.79 264.36 438.08 259.23 429.23 259.23C420.38 259.23 411.41 264.36 402.31 274.62C394.87 268.21 387.95 265.64 381.54 266.92C375.13 268.21 369.23 273.33 363.85 282.31C359.91 283.16 357.46 283.7 356.47 283.91C349.74 285.38 343.56 288.75 338.69 293.62C337.41 294.9 341.53 290.78 340.37 291.93C335.03 297.28 330.51 303.4 326.98 310.09C322.2 319.15 311.16 340.08 305.87 350.1C304.38 352.91 300.78 353.79 298.16 351.98C297.48 351.51 295.79 350.34 293.08 348.46",
  id: "b2jBzfYHpT"
}), React.createElement("path", {
  d: "",
  id: "b1UnUddYJ"
}), React.createElement("path", {
  d: "M171.54 433.85L171.54 399.23",
  id: "a2z9rZIRE3"
}), React.createElement("path", {
  d: "M414.62 433.85L414.62 404.62",
  id: "e4y362hP4r"
}), React.createElement("path", {
  d: "M185.38 419.23L185.38 399.23",
  id: "arHkoWYE"
}), React.createElement("path", {
  d: "M427.69 419.23L427.69 396.92",
  id: "a7xZYBSu6h"
})), React.createElement("g", {
  id: "shape-elements"
}, React.createElement("path", {
  d: "M439.42 277.04C443.66 279.01 446.58 283.02 447.15 287.66C447.3 288.91 447.69 292.05 448.3 297.07C444.41 295.96 441.98 295.27 441 294.99C435.55 293.44 431.47 288.9 430.51 283.32C430.12 281.05 430.05 280.63 429.54 277.68C429.12 275.28 431.57 273.4 433.78 274.42C436.27 275.58 437.25 276.03 439.42 277.04Z",
  id: "n3vKcceWL"
}), React.createElement("path", {
  d: "M524.15 277.04C519.91 279.01 516.99 283.02 516.42 287.66C516.27 288.91 515.88 292.05 515.26 297.07C519.16 295.96 521.59 295.27 522.56 294.99C528.01 293.44 532.09 288.9 533.06 283.32C533.45 281.05 533.52 280.63 534.03 277.68C534.45 275.28 532 273.4 529.79 274.42C527.3 275.58 526.32 276.03 524.15 277.04Z",
  id: "axEoeNLtu"
}), React.createElement("path", {
  d: "M525.01 308.86C530.88 297.84 522.9 284.54 510.41 284.54C504.87 284.54 515.79 284.54 510.25 284.54C510.25 284.54 455.14 284.54 455.14 284.54C449.59 284.54 460.52 284.54 454.97 284.54C442.49 284.54 434.5 297.84 440.37 308.86C443.31 314.37 439.16 306.59 442.1 312.11C442.1 312.11 468.01 360.75 468.01 360.75C470.94 366.27 466.8 358.49 469.74 364C475.26 374.37 490.12 374.37 495.64 364C498.58 358.49 494.44 366.27 497.38 360.75C497.38 360.75 523.28 312.11 523.28 312.11C526.22 306.59 522.08 314.37 525.01 308.86Z",
  id: "dOCDjPD2"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "112.86122661122661 254.33653846153857 421.21713195540394 179.50961538461524",
    width: 419,
    height: 177
  }, props), _ref, React.createElement("use", {
    xlinkHref: "#line-elements",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 5,
    strokeOpacity: 1,
    style: {
      "stroke": "currentColor"
    }
  }), React.createElement("use", {
    xlinkHref: "#shape-elements",
    opacity: 1,
    fill: "#currentColor",
    fillOpacity: 1,
    style: {
      "fill": "currentColor"
    }
  }));
};

export default __webpack_public_path__ + "static/media/lambtwist.3c1622f8.svg";
export { SvgComponent as ReactComponent };